import { AttendanceTrackingHeader } from 'components/molecules/AttendanceTrackingHeader';
import { AttendanceTrackingSidebar } from 'components/molecules/AttendanceTrackingSidebar';
import { useAttendanceTrackingAccess } from 'contexts/AttendanceTrackingAccessContext';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import React, { useCallback, useState } from 'react';
import { Outlet } from 'react-router-dom';
import './index.scss';

const STORAGE_KEY = 'attendance-tracking-sidebar-collapsed';

export const AttendanceTrackingLayout = () => {
  const { isAdmin } = useAttendanceTrackingAccess();
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem(STORAGE_KEY) === 'true'
  );

  const toggleCollapsed = useCallback(() => {
    setCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem(STORAGE_KEY, String(next));
      return next;
    });
  }, []);

  if (!isAdmin) {
    return (
      <>
        <AttendanceTrackingHeader />
        <main className="attendance-tracking-content attendance-tracking-content--upload-only">
          <Outlet />
        </main>
      </>
    );
  }

  return (
    <>
      <AttendanceTrackingHeader />
      <div
        className={`attendance-tracking-layout ${
          collapsed ? 'attendance-tracking-layout--collapsed' : ''
        }`}
      >
        <AttendanceTrackingSidebar collapsed={collapsed} />
        <button
          type="button"
          className="attendance-tracking-layout__rail"
          onClick={toggleCollapsed}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          aria-expanded={!collapsed}
        >
          {collapsed ? (
            <ChevronRightIcon fontSize="small" />
          ) : (
            <ChevronLeftIcon fontSize="small" />
          )}
        </button>
        <main className="attendance-tracking-content">
          <Outlet />
        </main>
      </div>
    </>
  );
};
